import { gql } from '@apollo/client';

export const LIVE_TAIL_QUERY = gql`
  query liveTail($filter: String!) {
    liveTail {
      getLogEntries(liveTailRequest: { filter: $filter, maxResults: 200 }) {
        continuationToken
        logEntry {
          facetsNumberLimitExceeded
          facetsWithTruncatedValues
          parentTimestamps
          serverInfo
          sessionId
          severity
          threadId
          timestamp
          type
          values
        }
      }
    }
  }
`;
